"use client";

import { poppins_hero_sm } from "@frontend/design-system";
import styled from "styled-components";

export const Title = styled.h2<{ $isLeftAlign: boolean }>`
  ${poppins_hero_sm};
  color: var(--Color-Common-Text-Interactive-Primary, #0198e9);
  width: ${({ $isLeftAlign }) => ($isLeftAlign ? "100%" : "")};
`;
